import React, { useState } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { LayoutDashboard, ShoppingBag, Cookie, Megaphone, Heart, MessageSquare, Settings, LogOut, Send, Bell, Users, Tag } from "lucide-react";
import { LOGO_URL } from "../lib/api";
import { useAuth } from "../context/AuthContext";

const NAV = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/orders", label: "Orders", icon: ShoppingBag },
  { to: "/admin/users", label: "Customers", icon: Users },
  { to: "/admin/promo-codes", label: "Promo Codes", icon: Tag },
  { to: "/admin/flavors", label: "Weekly Flavors", icon: Cookie },
  { to: "/admin/announcements", label: "Announcements", icon: Megaphone },
  { to: "/admin/pickup-email", label: "Pickup Email", icon: Send },
  { to: "/admin/notify", label: "Notify List", icon: Bell },
  { to: "/admin/custom-orders", label: "Custom Orders", icon: Heart },
  { to: "/admin/messages", label: "Messages", icon: MessageSquare },
  { to: "/admin/settings", label: "Settings", icon: Settings },
];

export default function AdminLayout() {
  const { logout, user } = useAuth();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);

  return (
    <div className="min-h-screen bg-[#F9FAFB] flex" data-testid="admin-layout">
      <aside className={`fixed lg:static inset-y-0 left-0 z-30 w-64 bg-[#111827] text-white flex flex-col transform ${open ? "translate-x-0" : "-translate-x-full"} lg:translate-x-0 transition-transform`}>
        <div className="p-6 border-b border-white/10 flex items-center gap-3">
          <img src={LOGO_URL} alt="Sugary Sweet" className="h-10 logo-white" />
          <div>
            <p className="font-display font-extrabold leading-none">Sugary Sweet</p>
            <p className="text-[10px] uppercase tracking-widest text-white/60">Admin</p>
          </div>
        </div>
        <nav className="flex-1 px-3 py-4 space-y-1">
          {NAV.map(n => {
            const Icon = n.icon;
            return (
              <NavLink
                key={n.to} to={n.to} end={n.end}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm font-semibold transition-colors ${
                    isActive ? "bg-white/10 text-white" : "text-white/70 hover:bg-white/5 hover:text-white"
                  }`
                }
                data-testid={`admin-nav-${n.label.toLowerCase().replace(/\s/g, "-")}`}
              >
                <Icon className="w-4 h-4" /> {n.label}
              </NavLink>
            );
          })}
        </nav>
        <div className="p-4 border-t border-white/10">
          <p className="text-xs text-white/60 mb-2">Signed in as <b>{user?.username}</b></p>
          <button onClick={() => { logout(); nav("/"); }} className="w-full flex items-center justify-center gap-2 bg-white/10 hover:bg-white/20 text-white text-sm font-bold py-2 rounded-xl" data-testid="admin-logout-btn">
            <LogOut className="w-4 h-4" /> Logout
          </button>
        </div>
      </aside>

      <div className="flex-1 min-w-0 lg:ml-0">
        <header className="lg:hidden flex items-center justify-between p-4 bg-white border-b border-gray-100">
          <button onClick={() => setOpen(true)} className="text-[#111827] font-bold">☰ Menu</button>
          <p className="font-display font-bold">Admin</p>
        </header>
        <main className="p-4 md:p-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
